import { css } from 'styled-components';

/**
 * Apple's HIG asks for 44×44pt, Material for 48dp. An antd text button is 32×32,
 * which is what the shell's icon buttons were.
 */
export const TOUCH_TARGET_SIZE = 44;

/**
 * Grows a control's hit area to `TOUCH_TARGET_SIZE` on the viewports the shell
 * treats as mobile, without touching the glyph or the desktop layout.
 *
 * Keyed off the viewport rather than `pointer: coarse`, deliberately: a pointer
 * query makes layout depend on the input device, and Chrome's element picker
 * suspends touch emulation while it is active — so inspecting a button in device
 * mode collapsed it back to 32px, and spacing appeared to change on its own.
 * `screenSMMax` is antd's own breakpoint, the same one `useBreakpoint().md`
 * flips at, so this stays in step with the JS that decides what to render.
 */
export const touchTargetStyles = css`
  @media (max-width: ${({ theme }) => theme.antd.screenSMMax}px) {
    min-width: ${TOUCH_TARGET_SIZE}px;
    min-height: ${TOUCH_TARGET_SIZE}px;
  }
`;
